import { storage } from './firebase';

export const uploadAvatar = async (url: string, id: string) => {
  const filePath = `avatars/${id}`;
  const blob = await fetch(url).then((r) => r.blob());
  const storageRef = storage.ref();
  const imgRef = storageRef.child(filePath);
  const snapshot = await imgRef.put(blob);
  const newUrl = await snapshot.ref.getDownloadURL();
  return newUrl;
};
export const fetchAvatar = async (id: string): Promise<string | undefined> => {
  try {
    const filePath = getAvatarPath(id);
    const storageRef = storage.ref();
    const imgRef = storageRef.child(filePath);
    const url = await imgRef.getDownloadURL();
    return url;
  } catch (error) {
    return undefined;
  }
};

export const getAvatarPath = (id: string): string => {
  return `avatars/${id}`;
};
